import React from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ApiLoading = () => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex-col tw-justify-center tw-items-center tw-gap-4 tw-inline-flex">
      <Spinner animation="border" variant="primary" />

      <div className="tw-text-center tw-text-gray-500 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">
        {t("LoadingComponent/text")}
      </div>
    </div>
  );
};

export default ApiLoading;
